import { useState } from 'react'
import { ContentCopyOutlined } from '@mui/icons-material'
import { Grid, IconButton, Tooltip, Typography, useTheme } from '@mui/material'

import { prettifyPhoneNumber } from '../../../utils/helpers'
import useClipboard from '../../../utils/hooks/useClipboard'
import useStyles from '../index.styles'

const ClickToContact = ({ text, protocol }: { text: string; protocol: 'tel' | 'mailto' }) => {
  const classes = useStyles
  const theme = useTheme()
  const { clickToCopy } = useClipboard()
  const [showCopy, setShowCopy] = useState<boolean>(false)

  return (
    <Grid
      container={true}
      data-testid="click-to-contact"
      onMouseEnter={() => setShowCopy(true)}
      onMouseLeave={() => setShowCopy(false)}
      sx={[
        {
          justifyContent: 'space-between',
        },
        classes.linkOnHoverContainer,
      ]}
    >
      <Tooltip title={protocol === 'tel' ? 'Call' : 'Email'} disableInteractive={true}>
        <Typography
          component="a"
          variant="body1"
          href={`${protocol}:${text}`}
          className="fs-exclude"
          sx={{ ...classes.truncatedText, ...classes.linkOnHover(theme) }}
          onFocus={() => setShowCopy(true)}
        >
          {protocol === 'tel' ? prettifyPhoneNumber(text) : text}
        </Typography>
      </Tooltip>
      {showCopy && (
        <Tooltip title="Copy" disableInteractive={true}>
          <IconButton
            size="small"
            sx={classes.copyIconButton}
            onClick={() => clickToCopy(text)}
            onBlur={() => setShowCopy(false)}
            aria-label={protocol === 'tel' ? 'Copy phone number to clipboard' : 'Copy email to clipboard'}
          >
            <ContentCopyOutlined sx={classes.copyIcon} />
          </IconButton>
        </Tooltip>
      )}
    </Grid>
  )
}

export default ClickToContact
